import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Navbar from './components/Navbar';
import CookieBanner from './components/CookieBanner';
import HomePage from './pages/HomePage';
import TerritoirePage from './pages/TerritoirePage';
// import TerritoireDetailPageV2 from './pages/TerritoireDetailPageV2';
import LancerVotreRadar from './pages/LancerVotreRadar';
import QuiSommesNousPage from './pages/QuiSommesNousPage';
import LoginPage from './pages/LoginPage';
// 1. ADD THE IMPORT HERE:
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import AdminPage from './pages/AdminPage';
import OrganisateurDashboard from './pages/OrganisateurDashboard';
import NewsDetailPage from './pages/NewsDetailPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import ConfidentialitePage from './pages/ConfidentialitePage';
import CookiesPage from './pages/CookiesPage';
import './styles/global.css';
import ResetPasswordPage from './pages/ResetPasswordPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function ProtectedRoute({ children, role }) {
  const { isAuthenticated, loading, user } = useAuth();
  if (loading) return <div style={{ paddingTop:120, textAlign:'center', color:'#8C7A6A' }}>Chargement...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role && user?.role !== role && user?.role !== 'admin') return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/"                 element={<HomePage />} />
        <Route path="/territoire" element={<TerritoirePage />} />
        <Route path="/territoire/:slug" element={<TerritoirePage />} />
        <Route path="/LancerVotreRadar"          element={<LancerVotreRadar />} />
        <Route path="/qui-sommes-nous"  element={<QuiSommesNousPage />} />
        <Route path="/actualites/:id"   element={<NewsDetailPage />} />
        {/* RGPD pages */}
        <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
        <Route path="/confidentialite"  element={<ConfidentialitePage />} />
        <Route path="/cookies"          element={<CookiesPage />} />
        {/* Auth */}
        <Route path="/login"            element={<LoginPage />} />
        
        {/* 2. ADD THE ROUTE RIGHT HERE: */}
        <Route path="/forgot-password"  element={<ForgotPasswordPage />} />
        <Route path="/reset-password"   element={<ResetPasswordPage />} />
        
        <Route path="/dashboard"        element={<ProtectedRoute role="organisateur"><OrganisateurDashboard /></ProtectedRoute>} />
        <Route path="/admin"            element={<ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>} />
        {/* Legacy redirects */}
        <Route path="/ressources"       element={<Navigate to="/LancerVotreRadar" replace />} />
        <Route path="/admin-login"      element={<Navigate to="/login" replace />} />
        <Route path="*"                 element={<Navigate to="/" replace />} />
      </Routes>
      {/* GDPR cookie consent banner — shown on all pages */}
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ScrollToTop />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}